<template>
  <section
    v-if="cms && cms.heading.length > 0"
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, spacing]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          alignContent: 'center',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
          alignContent: 'center',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <m-section-header-v2 :cms="cms" :class="`${name}__header`" />

        <div :class="`${name}__collection`">
          <div
            v-for="(item, index) in cms.collection"
            :key="index"
            :class="[`${name}__item`]"
          >
            <a-image-v2
              v-if="(item.image || {}).filename"
              :src="item.image.filename"
              :alt="item.image.alt"
              :layout="layout"
              :class="`${name}__image`"
            />
          </div>
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-clients/o-clients-v2.data'
import MSectionHeaderV2 from '~/components/molecules/m-section-heading/m-section-header-v2'

export default {
  components: { MSectionHeaderV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
    layout: {
      type: Array,
      default() {
        return [{ size: 0, bound: 313, ratio: [216, 216] }]
      },
    },
  },

  data() {
    return {
      name: 'o-awards-v2',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-awards-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: 100px 0;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  .grid {
    @include container();

    min-height: inherit;
    display: grid;
    align-content: center;
  }

  &__collection {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  &__image {
    min-height: 127px;
  }

  &__item {
    padding: 35px;
  }

  &__header {
    padding-top: 0;
  }
}

@include media-breakpoint-up(md) {
  .o-awards-v2 {
    &__collection {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

@include media-breakpoint-up(lg) {
  .o-awards-v2 {
    &__collection {
      grid-template-columns: repeat(6, 1fr);
    }
  }
}
</style>
